import {createSelector} from "reselect";
import {getAdminStoreState} from "../../store/admin-store-selectors";

export const getPatientsStoreState = createSelector(getAdminStoreState, state => state.patients);
